module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/md-efdfab01385b30e739862fd2fc165f48.svg";